import React, { useState, useRef, useEffect } from "react";
import "./attendance_item.css";
import Down from "../../../src/assets/images/imageIcons/down.png";

const AttendanceItem = ({ record, setAttendanceType, setActionModal, setAttendanceDate }) => {
  const [expanded, setExpanded] = useState(false);
  const dropdownRef = useRef(null);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (expanded && dropdownRef.current) {
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const isOverflowing = dropdownRect.right > window.innerWidth;

      if (isOverflowing) {
        dropdownRef.current.style.right = "auto";
        dropdownRef.current.style.left = "auto";
        dropdownRef.current.style.transform = "translateX(-80%)";
      } else {
        dropdownRef.current.style.right = "0";
        dropdownRef.current.style.transform = "none";
      }
    }
  }, [expanded]);

  // Helpers
  const getStatusClassName = (status) => {
    switch (status) {
      case "Present":
        return "status present";
      case "Absent":
        return "status absent";
      case "Weekly Off":
        return "status weekly-off";
      case "Holiday":
        return "status holiday";
      case "N.A.":
        return "status na";
      default:
        return "status";
    }
  };

  const formatTime = (timeStr) => {
    const date = new Date(timeStr);
    if (isNaN(date.getTime())) return "N.A.";
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
  };

  const formatDateParts = (dateStr) => {
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mmNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const mm = mmNames[date.getMonth()];
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const day = days[date.getDay()];
    return { dd, mm, day };
  };

  const encodeToBase64 = (data) => {
    const concatenatedData = data.join("|");
    return btoa(concatenatedData);
  };

  const { dd, mm, day } = formatDateParts(record?.date);
  const checkIn = formatTime(record?.punch_in_time);
  const checkOut = formatTime(record?.punch_out_time);

  const recordValues = [
    record?.date,
    dd,
    mm,
    day,
    record?.attendance_type,
    checkIn,
    checkOut,
  ];

  const base64Param = encodeToBase64(recordValues);

  const handleFullDay = () => {
    setAttendanceType("RegularisationFullDay");
    setAttendanceDate(record?.date);
    setActionModal(true);
  };

  const handleHalfDay = () => {
    setAttendanceType("RegularisationHalfDay");
    setAttendanceDate(record?.date);
    setActionModal(true);
  };

  const handleAbsentDay = () => {
    setAttendanceType("Overtime");
    setAttendanceDate(record?.date);
    setActionModal(true);
  };

  return (
    <>
      <div className="attendance-item">
        <div className="left-side">
          <div className="date">
            {dd} {mm}
            <br />
            {day}
          </div>
        </div>
        <div className="right-side">
          {record?.attendance_type === "Holiday" ? (
            <div className="holiday-status">
              {record?.attendance_type} {record?.holiday_name}
            </div>
          ) : (
            <div className={getStatusClassName(record?.attendance_type)}>
              {record?.attendance_type}
              {record?.attendance_type !== "N/A" && (
                <span className="time-container">
                  <img
                    src={Down}
                    alt=""
                    className={`down-image ${expanded ? "expanded" : ""}`}
                    onClick={toggleExpand}
                  />
                  {expanded && (
                    <div className="regularization-dropdown-menu" ref={dropdownRef}>
                      <p className="regularization-dropdown-item">
                        <button onClick={handleFullDay}>Mark Full Day</button>
                      </p>
                      <p className="regularization-dropdown-item">
                        <button onClick={handleHalfDay}>Mark Half Day</button>
                      </p>
                      {/* <p className="regularization-dropdown-item">
                        <button onClick={handleAbsentDay}>Mark Overtime</button>
                      </p> */}
                    </div>
                  )}
                </span>
              )}
            </div>
          )}
          <div className="time">
            <p>
              {record?.attendance_type === "N/A" && "N.A. ➔ N.A."}
              {record?.attendance_type === "Weekly Off" && "Weekly Off"}
              {record?.attendance_type === "Holiday" && "Holiday"}
              {record?.attendance_type !== "N/A" &&
                record?.attendance_type !== "Weekly Off" &&
                record?.attendance_type !== "Holiday" &&
                `${checkIn} ➔ ${checkOut}`}
            </p>
          </div>

          <div className="shift">{record?.shift}</div>

          {record?.is_sync && (
            <div
              className={`is-sync ${
                record?.is_sync === "(Synced with darwinbox)" ||
                record?.is_sync === "(Regularization Approved)"
                  ? "green"
                  : record?.is_sync === "(Regularization Pending)" ||
                    record?.is_sync === "(Changes will be synced today)"
                  ? "yellow"
                  : record?.is_sync === "(Regularization Rejected)"
                  ? "red"
                  : ""
              }`}
            >
              {record?.is_sync}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AttendanceItem;
